import React, { useEffect, useState, useMemo } from "react";
import { UserSiteContext } from "../..";
import { fetchUserInfo } from "../api/user";
import { fetchJobsiteList, fetchUserList } from "../api/project";
import { Common } from "../../common/src";
import { ProjectUserList } from "../../common/src/modules";
import i18n from "../locales/i18n";
import { CircularProgress } from "@mui/material";

type Props = {
  usingUserSiteContext: boolean;
  children: any;
};

const IntlWrapper = ({ usingUserSiteContext, children }: Props) => {
  const [userInfo, setUserInfo] = useState<Common.LandlogNecessaryUserInfo>();
  const [userList, setUserList] = useState<ProjectUserList[]>([]);
  const [jobsiteList, setJobsiteList] = useState<Common.LandlogJobSite[]>([]);
  const [loading, setLoading] = useState(true);
  const memoValue = useMemo(
    () => ({ userInfo, userList, jobsiteList }),
    [userInfo, userList, jobsiteList]
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userInfo = await fetchUserInfo();
        i18n.changeLanguage(userInfo.language);
        setUserInfo(userInfo);
        if (usingUserSiteContext) {
          setJobsiteList((await fetchJobsiteList()).sites);
          setUserList((await fetchUserList()) as Common.ProjectUserList[]);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div>
        <CircularProgress
          sx={{ position: "absolute", left: "50%", top: "50%" }}
        />
      </div>
    );
  }

  return (
    <UserSiteContext.Provider value={memoValue}>
      {children}
    </UserSiteContext.Provider>
  );
};

export default IntlWrapper;
